import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  CircularProgress,
  makeStyles,
  Checkbox,
  Typography,
} from "@material-ui/core";
import { useParams, useHistory } from "react-router-dom";

import { propertyDataArray } from "../../components/PropertyDataArray";
import { Select, DateInput } from "../../components/Form";
import Button from "../../components/Button";
import LoadingModal from "../../components/LoadingModal";

export default function BidWinningTable() {
  const history = useHistory();
  const useStyles = makeStyles({
    DocumentContainerCenter: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
  });
  const classes = useStyles();
  const { courtArray } = propertyDataArray();
  const sourceArray = [
    {
      label: "司法院",
      value: "司法院",
    },
    {
      label: "臺灣金服",
      value: "臺灣金服",
    },
  ];
  const timePeriodArray = [
    {
      label: "全天",
      value: "ALL",
    },
    {
      label: "上午",
      value: "AM",
    },
    {
      label: "下午",
      value: "PM",
    },
  ];
  const timeArray = [
    {
      label: "全部拍次",
      value: "ALL",
    },
    {
      label: "應買",
      value: "during",
    },
  ];

  const [newData, setNewData] = useState({
    courtObject: {
      label: "臺灣臺中地方法院",
      value: "TCD",
    },
    sourceObj: {
      label: "司法院",
      value: "司法院",
    },
    summaryTableBillingDate: new Date(),
    timeObject: {
      label: "全部拍次",
      value: "ALL",
    },
    timePeriod: "ALL",
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  if (false) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={false} />
        <CardContent>
          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Card>
                <CardHeader
                  title={"總表列印"}
                  style={{ textAlign: "center" }}
                />
                <CardContent>
                  <Grid container spacing={4}>
                    <Grid item container>
                      <Select
                        placeholder={"請選擇法院"}
                        items={courtArray}
                        value={newData.courtObject}
                        onChange={(e, value) => {
                          if (value) {
                            changeData("courtObject", value, true);
                          } else {
                            changeData("courtObject", {}, true);
                          }
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item container>
                      <Select
                        placeholder={"請選擇來源"}
                        items={sourceArray}
                        value={newData.sourceObj}
                        onChange={(e, value) => {
                          if (value) {
                            if (value.value === "臺灣金服")
                              changeData("timePeriod", "ALL");
                            changeData("sourceObj", value, true);
                          } else {
                            changeData("sourceObj", {}, true);
                          }
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item container>
                      <Select
                        placeholder={"請選擇拍次"}
                        items={timeArray}
                        value={newData.timeObject}
                        onChange={(e, value) => {
                          if (value) {
                            if (value.value === "during")
                              changeData("timePeriod", "ALL");
                            changeData("timeObject", value, true);
                          } else {
                            changeData("timeObject", {}, true);
                          }
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item container>
                      <DateInput
                        value={newData.summaryTableBillingDate}
                        onChange={(v) =>
                          changeData("summaryTableBillingDate", v, true)
                        }
                        format="yyyy-MM-dd"
                        views={["year", "month", "date"]}
                        fullWidth
                        label={"開標日"}
                      />
                    </Grid>
                    <Grid item container justify={"center"}>
                      {timePeriodArray.map((item, index) => {
                        return (
                          <Grid
                            item
                            classes={{ root: classes.DocumentContainerCenter }}
                            key={index}
                          >
                            <Checkbox
                              color="primary"
                              checked={Boolean(
                                newData.timePeriod === item.value
                              )}
                              onChange={() =>
                                changeData("timePeriod", item.value, true)
                              }
                              disabled={
                                newData.timeObject.value === "during" ||
                                newData.sourceObj.value === "臺灣金服"
                              }
                            />
                            <Typography color="primary">
                              {item.label}
                            </Typography>
                          </Grid>
                        );
                      })}
                    </Grid>
                    <Grid container item justify={"center"}>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={() => {
                          window.open(
                            `/console/property-table-print`,
                            "_blank",
                            "noopener"
                          );
                          localStorage.setItem(
                            "@fullhousePrint",
                            JSON.stringify(newData)
                          );
                        }}
                      >
                        查詢資料
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}
